<template>
  <VModal
    ref="modal"
    modal-classes="max-w-md mx-auto"
    disable-backdrop-click
    @modal:hidden="$emit('closed')"
  >
    <div class="rounded shadow-xs w-full max-w-lg mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
        <div class="h-10 bg-white pl-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Update Link</h1>
            </div>
            <div class="flex-none">
              <button
                class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                    4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                    4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                    5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div v-if="!loading" class="p-10">
          <AssetLink
            :tags="tags"
            :default-data="defaultData"
            :action="tryUpdateAssetLink"
            label="Update Link"
            @success="$refs.modal.close()"
          />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import { assetsClient, accountAssetTagsClient } from '@/api/clients';
import AssetLink from '@/forms/AssetLinkForm.vue';

export default {
  name: 'AccountLinkAssetUpdateModal',
  components: {
    AssetLink,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tags: [],
    };
  },
  computed: {
    defaultData() {
      const { url, title, description } = this.link;
      return {
        url,
        title,
        description,
        tags: [...this.asset.tags],
      };
    },
    link() {
      return this.$store.state.entities.links.byId[this.asset.assetableId] || {};
    },
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        await this.tryFetchAccountAssetTagList();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async tryFetchAccountAssetTagList() {
      try {
        const response = await accountAssetTagsClient.list(this.asset.accountId);

        this.tags = response?.data?.data || [];
      } catch (error) {
        //
      }
    },
    async tryUpdateAssetLink(formData) {
      try {
        const {
          data: { data },
        } = await assetsClient.updateLink(this.asset.id, formData);

        const assetId = await this.$store.dispatch('entities/persistEntities', {
          type: 'assets',
          data,
        });

        this.$emit('updated', assetId);

        return Promise.resolve(assetId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
